import Axios, { AxiosRequestConfig } from 'axios'
import { ANONYMOUS_USER_TOKEN_LS_KEY } from 'constants/ls'
import { resolveEnvUrlWithWindow } from '../../helpers/dynamic-url'

const baseURL = resolveEnvUrlWithWindow(import.meta.env.VITE_AXIOS_BASE_URL)

const config = {
  baseURL,
  timeout: 120000,
  timeoutErrorMessage: 'Request takes more than 120 seconds'
}

export const AXIOS_INSTANCE = Axios.create(config)

// shape thrown by the .catch below - the react-query error type for every
// generated hook should be `ApiError<...>`, not the raw response body type,
// since `status` lives alongside `data`, not inside it
export type ApiError<T> = {
  data: T
  status: number
}

export const platformInstance = <T>(
  requestConfig: AxiosRequestConfig
): Promise<T> => {
  const accessToken =
    localStorage.getItem('token') ??
    localStorage.getItem(ANONYMOUS_USER_TOKEN_LS_KEY)

  const signal = requestConfig.signal
  const promise = AXIOS_INSTANCE({
    ...requestConfig,
    signal,
    headers: {
      ...requestConfig.headers,
      ...(accessToken
        ? {
            Authorization: `Bearer ${encodeURIComponent(accessToken ?? '')}`
          }
        : {})
    }
  })
    .then(({ data }) => data)
    .catch((error) => {
      throw { data: error.response.data, status: error.response.status }
    })

  return promise
}
